import { loginBackgroundPattern } from 'images/';
import styled from 'styled-components/macro';

import { Card, Flex } from '@olist/united';

export const PreSignupWrapper = styled(Flex).attrs({
  backgroundColor: 'foundation.primaryDefault',
})`
  background-image: url(${loginBackgroundPattern});
  background-repeat: repeat-x;
  background-position-x: -35px;
  background-position-y: -350px;
  min-height: 100vh;
`;

export const PreSignupCard = styled(Card)`
  padding: 32px;
`;
